export const voiceOptions = [
    { id: 'iP95p4xoKVk53GoZ742B', name: 'DefaultDave' },
    { id: 'pNInz6obpgDQGcFmaJgB', name: 'Adam' },
    { id: 'IKne3meq5aSn9XLyUdCD', name: 'Charlie' },
    { id: '2EiwWnXFnvU5JabPnv8n', name: 'Clyde' },
    { id: 'ThT5KcBeYPX3keUQqHPh', name: 'Dorothy' },
    { id: 'jsCqWAovK2LkecY7zXl4', name: 'Freya' },
    { id: 'jBpfuIE2acCO8z3wKNLl', name: 'Gigi' },
    { id: 'SOYHLrjzK2X1ezoPC6cr', name: 'Harry' },
    { id: 'ZQe5CZNOzWyzPSCn5a3c', name: 'James' },
    { id: 'pFZP5JQG7iQjIQuC4Bku', name: 'Lily' },
    { id: '21m00Tcm4TlvDq8ikWAM', name: 'Rachel' },
];

export const supportedLocales = [
    { id: "en-US", name: "English (US)" },
    { id: "en-GB", name: "English (UK)" },
    { id: "es-ES", name: "Spanish (Español - Spain)" },
    { id: "es-MX", name: "Spanish (Español - Mexico)" },
    { id: "fr-FR", name: "French (Français - France)" },
    { id: "fr-CA", name: "French (Français - Canada)" },
    { id: "de-DE", name: "German (Deutsch)" },
    { id: "zh-CN", name: "Chinese (Simplified)" },
    { id: "zh-TW", name: "Chinese (Traditional)" },
    { id: "ja-JP", name: "Japanese (日本語)" },
    { id: "ko-KR", name: "Korean (한국어)" },
    { id: "pt-PT", name: "Portuguese (Portugal)" },
    { id: "pt-BR", name: "Portuguese (Brazil)" },
    { id: "it-IT", name: "Italian (Italiano)" },
    { id: "nl-NL", name: "Dutch (Nederlands)" },
    { id: "ru-RU", name: "Russian (Русский)" },
    { id: "ar-SA", name: "Arabic (العربية)" },
    { id: "hi-IN", name: "Hindi (हिन्दी)" },
    { id: "bn-BD", name: "Bengali (বাংলা)" },
    { id: "sv-SE", name: "Swedish (Svenska)" },
    { id: "no-NO", name: "Norwegian (Norsk)" },
    { id: "da-DK", name: "Danish (Dansk)" },
    { id: "fi-FI", name: "Finnish (Suomi)" },
    { id: "pl-PL", name: "Polish (Polski)" },
    { id: "tr-TR", name: "Turkish (Türkçe)" },
    { id: "cs-CZ", name: "Czech (Čeština)" },
    { id: "hu-HU", name: "Hungarian (Magyar)" },
    { id: "sw-KE", name: "Swahili (Kiswahili)" },
    { id: "ur-PK", name: "Urdu (اردو)" },
    { id: "ms-MY", name: "Malay (Bahasa Melayu)" },
    { id: "tl-PH", name: "Tagalog (Filipino)" },
    { id: "fa-IR", name: "Farsi (فارسی)" },
    { id: "el-GR", name: "Greek (Ελληνικά)" },
    { id: "he-IL", name: "Hebrew (עברית)" },
    { id: "th-TH", name: "Thai (ไทย)" },
    { id: "vi-VN", name: "Vietnamese (Tiếng Việt)" },
];

export const defaultBusinessOpen = "09:00";
export const defaultBusinessClose = "17:00";

export const projectSecretaryContactEmail = 'info@projectsecretary.net';
export const projectSecretaryContactPhoneDisplay = '0330 052 3699';
export const projectSecretaryContactPhoneHref = 'tel:03300523699';
export const projectSecretaryPublicDemoBusinessId = 432;
export const projectSecretaryPublicDemoCallPrefix = 'PD';
